import { useState } from 'react';

const useAuth = () => {
    const [token, setToken] = useState(() =>
        localStorage.getItem('authToken') || null
    );
    const [admin, setAdmin] = useState(() =>
        localStorage.getItem('admin') ? JSON.parse(localStorage.getItem('admin')) : null
    );

    const loginAdmin = async (username, password) => {
        try {
            const response = await fetch('https://collect.geocene.com/admin-token/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ username, password }),
            });

            const data = await response.json();

            if (response.ok) {
                const authToken = data.token;
                setToken(authToken);
                setAdmin({
                    username: username,
                    isAdmin: true,
                });
                localStorage.setItem('authToken', authToken);
                localStorage.setItem('admin', JSON.stringify({ username, isAdmin: true }));
                return { success: true };
            } else {
                return { success: false, message: data.detail || 'Authentication failed' };
            }
        } catch (error) {
            console.error('Login error:', error);
            return { success: false, message: 'Network error occurred' };
        }
    };

    const logoutAdmin = () => {
        setToken(null);
        setAdmin(null);
        localStorage.removeItem('authToken');
        localStorage.removeItem('admin');
    };

    return { token, admin, loginAdmin, logoutAdmin };
};

export default useAuth;
